export default {

    emits: ['update:hover'],

    props: {

        // Whether a 'hover' state on the component shall be shown
        // Supports the 'v-model:hover' modfier
        hover: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            isHovered: this.hover
        }
    },

    watch: {
        hover(hover) {
            this.isHovered = hover;
        },

        isHovered(hover) {
            this.$emit('update:hover', hover)
        }
    },

    beforeUnmount() {
        if (this.$el) {
            this.$el.removeEventListener("mouseover", this.onMouseover);
            this.$el.removeEventListener("mouseleave", this.onMouseleave);
        }
    },

    mounted() {
        // Listeners required with Vanilla JS since we have dynamic component tags
        this.$el.addEventListener("mouseover", this.onMouseover);
        this.$el.addEventListener("mouseleave", this.onMouseleave);
    },

    methods: {
        onMouseover() {
            this.isHovered = true;
        },
        onMouseleave() {
            this.isHovered = false;
        }
    }
}
